import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    tag: "Recommended",
    tagColor: "bg-[#1A365D] text-white",
    speed: "2–9",
    unit: "days",
    label: "Fast Passport Center Expedited",
    highlight: true,
    features: [
      "No appointment needed — we handle agency submission",
      "Dedicated agent reviews your application for errors",
      "Reserved courier slots at U.S. passport agencies",
      "Daily status updates via phone or email",
      "Not affected by government shutdowns",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
    ],
  },
  {
    tag: "Standard Expedited",
    tagColor: "bg-green-50 text-green-700",
    speed: "3–5",
    unit: "weeks",
    label: "Post Office Expedited",
    smartSaver: true,
    features: [
      "Available at Sioux Falls post office",
      "You pay government + post office fees",
      "You handle all paperwork yourself",
      "No dedicated support — DIY process",
      "Mailing delays can add 1–2 weeks",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
    ],
    highlight: false,
  },
  {
    tag: "Routine",
    tagColor: "bg-gray-100 text-gray-500",
    speed: "6–11",
    unit: "weeks",
    label: "Routine Post Office",
    muted: true,
    features: [
      "Cheapest option — government fee only",
      "Must visit post office in person",
      "No tracking or status updates available",
      "Longest wait — not recommended for travel",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
    ],
    highlight: false,
  },
  {
    tag: "Emergency",
    tagColor: "bg-red-50 text-red-600",
    speed: "24h",
    unit: "or less",
    label: "Life-or-Death Emergency",
    emergency: true,
    features: [
      "Must have documented emergency & travel within 72 hours",
      "Appointment required at Minneapolis or Denver Regional Agency",
      "You apply in person — no courier service",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
    ],
    highlight: false,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Sioux Falls"
      headingExtra="SD"
      introText="Sioux Falls residents have multiple paths to a passport — but South Dakota has zero passport agencies anywhere in the state, which makes last-minute and emergency processing a serious logistical challenge. Here's how each option stacks up."
      options={options}
      emergencyDescription="Strictly for documented life-or-death emergencies. The closest passport agency is Minneapolis — ~240 miles via I-90, a 4+ hour drive one way. Denver is ~500 miles, 7+ hour drive. South Dakota has no passport agency. Winter storms frequently close highways, making emergency agency visits unreliable."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. South Dakota has no passport agency — nearest agencies are in Minneapolis and Denver."
    />
  );
}